const pic_logo = require('./logo.png');
const bar = require('./bar.png');

export { pic_logo, bar }